import { Link } from 'react-router-dom';

export default function TermosDeUso() {
  return (
    <div className="min-h-screen bg-stone-50">
      {/* Header */}
      <header className="bg-stone-900 py-5 px-6 md:px-12">
        <div className="max-w-4xl mx-auto flex items-center justify-between">
          <Link to="/" className="font-black text-white text-lg cursor-pointer">
            TRANSFORMAÇÃO REAL <span className="text-amber-400">60D</span>
          </Link>
          <Link
            to="/"
            className="flex items-center gap-2 text-white/60 hover:text-white text-sm transition-colors cursor-pointer"
          >
            <i className="ri-arrow-left-line" />
            Voltar ao site
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-6 md:px-12 py-16 md:py-24">
        <div className="mb-12">
          <p className="text-xs font-semibold tracking-[0.2em] uppercase text-stone-400 mb-3">Documento legal</p>
          <h1 className="text-4xl md:text-5xl font-black text-gray-900 mb-4">Termos de Uso</h1>
          <p className="text-stone-500 text-sm">Última atualização: 15 de abril de 2026</p>
        </div>

        <div className="bg-white rounded-2xl border border-stone-100 p-8 md:p-12 space-y-10 text-gray-700 leading-relaxed">

          <section>
            <h2 className="text-xl font-black text-gray-900 mb-4">1. Aceitação dos Termos</h2>
            <p className="text-sm leading-relaxed">
              Ao acessar e utilizar o site <strong>Transformação Real 60D</strong> (doravante "Programa"), você concorda
              com os presentes Termos de Uso. Caso não concorde com qualquer disposição aqui prevista, solicitamos que
              não utilize nossos serviços. O uso continuado do site após eventuais alterações nos Termos implica
              aceitação das novas condições.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-black text-gray-900 mb-4">2. Descrição do Serviço</h2>
            <p className="text-sm leading-relaxed mb-3">
              O Transformação Real 60D é um programa intensivo de reestruturação empresarial voltado a pequenos e médios
              empresários, com duração de 60 dias. O programa oferece:
            </p>
            <ul className="space-y-2 text-sm">
              {[
                'Diagnóstico estrutural do negócio (Mapa de Gargalos e Alavancas)',
                'Organização da gestão e estrutura operacional',
                'Reestruturação financeira com controle de fluxo de caixa',
                'Construção de estrutura comercial e funil de vendas',
                'Estratégias de inovação e eficiência empresarial',
                'Implementação de ferramentas de Inteligência Artificial',
              ].map((item) => (
                <li key={item} className="flex items-start gap-3">
                  <span className="w-1.5 h-1.5 rounded-full bg-amber-400 shrink-0 mt-2" />
                  {item}
                </li>
              ))}
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-black text-gray-900 mb-4">3. Elegibilidade</h2>
            <p className="text-sm leading-relaxed">
              O programa é destinado a empresários e empreendedores maiores de 18 anos com negócio ativo ou em fase de
              estruturação. Ao se inscrever, você declara que possui capacidade legal para celebrar contratos e que as
              informações fornecidas são verdadeiras e completas.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-black text-gray-900 mb-4">4. Propriedade Intelectual</h2>
            <p className="text-sm leading-relaxed">
              Todo o conteúdo disponibilizado no programa — incluindo materiais didáticos, planilhas, ferramentas,
              metodologias, vídeos, textos e demais recursos — é de propriedade exclusiva do Transformação Real 60D e
              está protegido pelas leis de direitos autorais. É expressamente proibido reproduzir, distribuir,
              comercializar ou utilizar qualquer material sem autorização prévia e por escrito.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-black text-gray-900 mb-4">5. Responsabilidades do Participante</h2>
            <p className="text-sm leading-relaxed mb-3">O participante se compromete a:</p>
            <ul className="space-y-2 text-sm">
              {[
                'Utilizar os materiais e ferramentas exclusivamente para fins pessoais e empresariais próprios',
                'Não compartilhar credenciais de acesso com terceiros',
                'Não reproduzir ou distribuir o conteúdo do programa sem autorização',
                'Manter conduta respeitosa nas interações com a equipe e demais participantes',
                'Fornecer informações verdadeiras no momento da inscrição',
              ].map((item) => (
                <li key={item} className="flex items-start gap-3">
                  <span className="w-1.5 h-1.5 rounded-full bg-amber-400 shrink-0 mt-2" />
                  {item}
                </li>
              ))}
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-black text-gray-900 mb-4">6. Política de Reembolso</h2>
            <p className="text-sm leading-relaxed">
              O participante tem direito a solicitar reembolso integral em até <strong>7 (sete) dias corridos</strong>{' '}
              após a data de confirmação da inscrição, conforme previsto no Código de Defesa do Consumidor (Lei nº
              8.078/1990) e no Decreto nº 7.962/2013. Após esse prazo, não serão realizados reembolsos. Para solicitar
              o cancelamento, entre em contato pelo e-mail:{' '}
              <strong>contato@xlabstudio.com.br</strong>.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-black text-gray-900 mb-4">7. Limitação de Responsabilidade</h2>
            <p className="text-sm leading-relaxed">
              O Transformação Real 60D oferece metodologias, ferramentas e orientações baseadas em experiência prática.
              No entanto, os resultados obtidos dependem exclusivamente do empenho, dedicação e aplicação de cada
              participante. Não garantimos resultados financeiros específicos. O programa não se responsabiliza por
              decisões empresariais tomadas com base no conteúdo apresentado.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-black text-gray-900 mb-4">8. Modificações nos Termos</h2>
            <p className="text-sm leading-relaxed">
              Reservamo-nos o direito de alterar estes Termos de Uso a qualquer momento. As alterações entrarão em
              vigor imediatamente após a publicação no site. Recomendamos que você revise periodicamente este documento.
              O uso continuado do programa após as alterações constitui aceitação dos novos termos.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-black text-gray-900 mb-4">9. Lei Aplicável e Foro</h2>
            <p className="text-sm leading-relaxed">
              Estes Termos de Uso são regidos pelas leis da República Federativa do Brasil. Fica eleito o foro da
              comarca de <strong>Manaus, Amazonas</strong>, com exclusão de qualquer outro, por mais privilegiado que
              seja, para dirimir quaisquer controvérsias decorrentes deste instrumento.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-black text-gray-900 mb-4">10. Contato</h2>
            <p className="text-sm leading-relaxed">
              Em caso de dúvidas sobre estes Termos de Uso, entre em contato conosco:
            </p>
            <div className="mt-4 bg-stone-50 rounded-xl p-5 space-y-2 text-sm">
              <p><strong>Transformação Real 60D</strong></p>
              <p>Manaus, Amazonas — AM, Brasil</p>
              <p>E-mail: contato@xlabstudio.com.br</p>
              <p>WhatsApp: (92) 98439-8338</p>
            </div>
          </section>

        </div>

        {/* Bottom nav */}
        <div className="mt-10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <Link
            to="/"
            className="flex items-center gap-2 text-stone-500 hover:text-stone-800 text-sm transition-colors cursor-pointer"
          >
            <i className="ri-arrow-left-line" />
            Voltar ao site
          </Link>
          <Link
            to="/politica-de-privacidade"
            className="flex items-center gap-2 text-stone-500 hover:text-stone-800 text-sm transition-colors cursor-pointer"
          >
            Ver Política de Privacidade
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-stone-900 py-6 px-6 mt-8">
        <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/30 text-xs">© 2026 Transformação Real 60D. Todos os direitos reservados.</p>
          <div className="flex items-center gap-6">
            <Link to="/termos-de-uso" className="text-amber-400 text-xs font-semibold">Termos de Uso</Link>
            <Link to="/politica-de-privacidade" className="text-white/30 hover:text-white/60 text-xs transition-colors">Política de Privacidade</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
